import { createFileRoute, redirect } from '@tanstack/react-router'
import { AnnouncementsPage } from '../pages/announcements/AnnouncementsPage'
import { msalInstance } from '../api/auth'

export const Route = createFileRoute('/announcements')({
  component: AnnouncementsPage,
  beforeLoad: () => {
    const account = msalInstance.getActiveAccount()
    const roles = account?.idTokenClaims?.roles || []

    if (!roles.includes('Manage.All')) {
      throw redirect({
        to: '/',
        search: { error: 'insufficient_permissions' }
      })
    }
  },
})
